// "use client";

// import React, { useEffect, useRef, useState, useMemo } from "react";
// import { useSelector } from "react-redux";
// import { useParams, useNavigate } from "react-router-dom";
// import { toast } from "react-hot-toast";

// import {
//   useGetCourseBySlugQuery,
//   useGetCourseProgressQuery,
// } from "@/features/api/courseApi";

// import { Button } from "@/components/ui/button";
// import { Card, CardContent, CardFooter } from "@/components/ui/card";
// import { Progress } from "@/components/ui/progress";
// import { Skeleton } from "@/components/ui/skeleton";

// import {
//   CheckCircle2,
//   PlayCircle,
//   ArrowRight,
//   BookOpen,
//   ChevronRight,
// } from "lucide-react";

// import DOMPurify from "dompurify";

// /* ================= EXERCISES ================= */
// import MultipleChoiceExercise from "@/assets/AllCourses/Exercises/MultipleChoice";
// import FillInTheBlanksExercise from "@/assets/AllCourses/Exercises/FillInTheBlanks";
// import PictureFillInTheBlanksExercise from "@/assets/AllCourses/Exercises/PictureFillInTheBlanks";
// import MatchingExercise from "@/assets/AllCourses/Exercises/Matching";
// import PronunciationExercise from "@/assets/AllCourses/Exercises/Pronunciation";
// import ListeningExercise from "@/assets/AllCourses/Exercises/Listening";
// import DragAndDropExercise from "@/assets/AllCourses/Exercises/DragAndDrop";
// import CategorizingWordsExercise from "@/assets/AllCourses/Exercises/CategorizingWords";
// import CircleTheCorrectWordExercise from "@/assets/AllCourses/Exercises/CircleTheCorrectWord";
// import CompleteTheConversationExercise from "@/assets/AllCourses/Exercises/CompleteTheConversation";
// import CompleteTheSentencesExercise from "@/assets/AllCourses/Exercises/CompleteTheSentences";
// import CrosswordExercise from "@/assets/AllCourses/Exercises/Crossword";
// import MissingAlphabetsExercise from "@/assets/AllCourses/Exercises/MissingAlphabets";
// import SentenceJumblesExercise from "@/assets/AllCourses/Exercises/SentenceJumbles";
// import StressingSyllableWordsExercise from "@/assets/AllCourses/Exercises/StressingSyllableWords";
// import VocabularyBuildingExercise from "@/assets/AllCourses/Exercises/VocabularyBuilding";
// import WordFormationExercise from "@/assets/AllCourses/Exercises/WordFormation";
// import WordJumblesExercise from "@/assets/AllCourses/Exercises/WordJumbles";

// /* ================= HELPERS ================= */
// const exerciseComponents = {
//   "multiple-choice": MultipleChoiceExercise,
//   "fill-in-the-blanks": FillInTheBlanksExercise,
//   "picture-fill-in-the-blanks": PictureFillInTheBlanksExercise,
//   matching: MatchingExercise,
//   pronunciation: PronunciationExercise,
//   listening: ListeningExercise,
//   "drag-and-drop": DragAndDropExercise,
//   "categorizing-words": CategorizingWordsExercise,
//   "circle-the-correct-word": CircleTheCorrectWordExercise,
//   "complete-the-conversation": CompleteTheConversationExercise,
//   "complete-the-sentences": CompleteTheSentencesExercise,
//   crossword: CrosswordExercise,
//   "missing-alphabets": MissingAlphabetsExercise,
//   "sentence-jumbles": SentenceJumblesExercise,
//   "stressing-syllable-words": StressingSyllableWordsExercise,
//   "vocabulary-building": VocabularyBuildingExercise,
//   "word-formation": WordFormationExercise,
//   "word-jumbles": WordJumblesExercise,
//   "exercise-section": () => null,
// };

// const getStudentExerciseTitle = (ex, index) =>
//   ex?.title?.trim() ? ex.title : `Exercise ${index + 1}`;

// const hasValidHtml = (html) =>
//   typeof html === "string" && html.replace(/<[^>]*>/g, "").trim().length > 0;

// /* ================= COMPONENT ================= */
// export default function CourseLearningPage() {
//   const { slug } = useParams();
//   const navigate = useNavigate();
//   const user = useSelector((s) => s.auth?.user);

//   const videoRef = useRef(null);
//   const exerciseRefs = useRef([]);

//   const [currentLessonId, setCurrentLessonId] = useState(null);
//   const [expandedLessonId, setExpandedLessonId] = useState(null);
//   const [currentExerciseIndex, setCurrentExerciseIndex] = useState(null);
//   const [completedLessons, setCompletedLessons] = useState([]);
//   const [exerciseAttempts, setExerciseAttempts] = useState({});
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [isVideoCompleted, setIsVideoCompleted] = useState(false);

//   const { data, isLoading, error } = useGetCourseBySlugQuery(slug);
//   const course = data?.course;

//   const { data: progressData, isLoading: progressLoading } =
//     useGetCourseProgressQuery(course?._id, {
//       skip: !course?._id || !user,
//     });

//   const lessons = useMemo(() => course?.lessons || [], [course]);

//   const currentLesson = useMemo(() => {
//     if (!currentLessonId && lessons.length > 0) return lessons[0];
//     return lessons.find((l) => l._id === currentLessonId) || lessons[0] || null;
//   }, [currentLessonId, lessons]);

//   const exercises = currentLesson?.exercises || [];

//   /* ================= GROUP EXERCISES FOR TOC ================= */
//   const groupedExercisesForTOC = useMemo(() => {
//     const groups = [];
//     let currentGroup = { title: "Exercises", exercises: [] };

//     exercises.forEach((ex, index) => {
//       if (ex.type === "exercise-section") {
//         if (currentGroup.exercises.length > 0) groups.push(currentGroup);
//         currentGroup = {
//           title: ex.title?.trim() || "Untitled Section",
//           exercises: [],
//         };
//       } else {
//         currentGroup.exercises.push({ ...ex, originalIndex: index });
//       }
//     });

//     if (currentGroup.exercises.length > 0) groups.push(currentGroup);
//     return groups;
//   }, [exercises]);

//   /* ================= SCROLL SPY - SYNC TOC WITH SCROLLING ================= */
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         const visibleEntries = entries
//           .filter((entry) => entry.isIntersecting)
//           .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

//         if (visibleEntries.length > 0) {
//           const index = Number(visibleEntries[0].target.dataset.index);
//           setCurrentExerciseIndex(index);
//         }
//       },
//       {
//         rootMargin: "-30% 0px -60% 0px",
//         threshold: [0, 0.1, 0.5, 1],
//       }
//     );

//     exerciseRefs.current.forEach((el) => el && observer.observe(el));

//     return () => observer.disconnect();
//   }, [exercises]);

//   /* ================= LOAD PROGRESS & AUTO-EXPAND CURRENT LESSON ================= */
//   useEffect(() => {
//     if (!progressData || !lessons.length) return;

//     setCompletedLessons(progressData.completedLessons || []);
//     const lessonId = progressData.currentLessonId || lessons[0]?._id;
//     setCurrentLessonId(lessonId);
//     setExpandedLessonId(lessonId); // Auto-expand current lesson
//   }, [progressData, lessons]);

//   /* ================= VIDEO COMPLETION ================= */
//   useEffect(() => {
//     setIsVideoCompleted(!currentLesson?.videoUrl);
//   }, [currentLesson]);

//   /* ================= EXERCISE HANDLING ================= */
//   const handleExerciseComplete = (id, correct) =>
//     setExerciseAttempts((prev) => ({ ...prev, [id]: correct }));

//   const allExercisesDone =
//     Object.keys(exerciseAttempts).length === exercises.length;

//   /* ================= LOADING STATES ================= */
//   if (isLoading || progressLoading) {
//     return (
//       <div className="p-8 space-y-4">
//         <Skeleton className="h-10 w-96" />
//         <Skeleton className="h-64 w-full" />
//         <Skeleton className="h-32 w-full" />
//       </div>
//     );
//   }

//   if (error || !course) {
//     return <div className="p-8 text-red-600">Failed to load course</div>;
//   }

//   /* ================= RENDER ================= */
//   return (
//     <div className="flex flex-col lg:flex-row gap-8 p-6 bg-gray-50 min-h-screen">
//       {/* ================= TOC - FULLY SYNCED ================= */}
//       <aside className="lg:w-80 bg-white p-6 rounded-xl shadow-lg lg:sticky top-6 h-fit max-h-[calc(100vh-3rem)] overflow-y-auto">
//         <div className="flex items-center gap-3 mb-6">
//           <BookOpen className="w-7 h-7 text-blue-600" />
//           <h2 className="font-bold text-xl">{course.title}</h2>
//         </div>

//         <Progress value={progressData?.percentage || 0} className="h-3 mb-2" />
//         <p className="text-sm text-gray-500 mb-6">
//           {Math.round(progressData?.percentage || 0)}% Completed
//         </p>

//         <nav className="space-y-2">
//           {lessons.map((lesson) => {
//             const isActiveLesson = lesson._id === currentLessonId;
//             const isExpanded = expandedLessonId === lesson._id;
//             const isCompleted = completedLessons.includes(lesson._id);

//             return (
//               <div key={lesson._id} className="space-y-1">
//                 <button
//                   onClick={() => {
//                     setCurrentLessonId(lesson._id);
//                     setExpandedLessonId(isExpanded ? null : lesson._id);
//                   }}
//                   className={`w-full text-left p-3 rounded-lg flex items-center gap-3 transition-all duration-200
//                     ${isActiveLesson
//                       ? "bg-blue-100 border-l-4 border-blue-600 font-semibold text-blue-900 shadow-sm"
//                       : "hover:bg-gray-100"
//                     }`}
//                 >
//                   {isCompleted ? (
//                     <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" />
//                   ) : (
//                     <PlayCircle className="w-5 h-5 text-gray-400 flex-shrink-0" />
//                   )}
//                   <span className="flex-1 truncate">{lesson.title}</span>
//                   <ChevronRight
//                     className={`w-5 h-5 transition-transform duration-200 flex-shrink-0
//                       ${isExpanded ? "rotate-90" : ""}`}
//                   />
//                 </button>

//                 {/* TOC Content - Only for expanded & active lesson */}
//                 {isExpanded && isActiveLesson && (
//                   <div className="ml-8 mt-3 space-y-4 border-l-2 border-gray-200 pl-4">
//                     {groupedExercisesForTOC.map((group, groupIndex) => {
//                       const hasActiveExercise = group.exercises.some(
//                         (ex) => ex.originalIndex === currentExerciseIndex
//                       );

//                       return (
//                         <div key={groupIndex} className="space-y-1">
//                           {/* Subtitle - Highlight if active */}
//                           <h4
//                             className={`text-sm font-bold pl-2 transition-colors
//                               ${hasActiveExercise ? "text-blue-700" : "text-gray-700"}
//                             `}
//                           >
//                             {group.title}
//                           </h4>

//                           {/* Exercises - Highlight active one */}
//                           {group.exercises.map((ex) => {
//                             const idx = ex.originalIndex;
//                             const title = getStudentExerciseTitle(ex, idx);
//                             const isActive = currentExerciseIndex === idx;

//                             return (
//                               <button
//                                 key={idx}
//                                 onClick={() => {
//                                   document
//                                     .getElementById(`exercise-${idx}`)
//                                     ?.scrollIntoView({
//                                       behavior: "smooth",
//                                       block: "center",
//                                     });
//                                 }}
//                                 className={`w-full text-left px-5 py-2.5 rounded-lg text-sm transition-all duration-200
//                                   ${isActive
//                                     ? "bg-blue-100 text-blue-800 font-semibold border-l-4 border-blue-600 shadow-sm -ml-4 pl-8"
//                                     : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
//                                   }`}
//                               >
//                                 {title}
//                               </button>
//                             );
//                           })}
//                         </div>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </nav>
//       </aside>

//       {/* ================= MAIN CONTENT ================= */}
//       <main className="flex-1">
//         <Card className="shadow-xl">
//           <CardContent className="space-y-16 py-10">
//             <h1 className="text-4xl font-bold text-blue-900">
//               {currentLesson.title}
//             </h1>

//             {currentLesson.videoUrl && (
//               <div className="max-w-5xl mx-auto rounded-xl overflow-hidden border shadow">
//                 <video
//                   ref={videoRef}
//                   controls
//                   className="w-full aspect-video bg-black"
//                   src={currentLesson.videoUrl}
//                   onEnded={() => setIsVideoCompleted(true)}
//                 >
//                   Your browser does not support the video tag.
//                 </video>
//               </div>
//             )}

//             {exercises.map((ex, i) => {
//               const Comp = exerciseComponents[ex.type];
//               const isSection = ex.type === "exercise-section";
//               if (!Comp) return null;

//               return (
//                 <section
//                   key={i}
//                   id={`exercise-${i}`}
//                   ref={(el) => (exerciseRefs.current[i] = el)}
//                   data-index={i}
//                   className="scroll-mt-32"
//                 >
//                   <h3 className="text-2xl font-semibold mb-6">
//                     {isSection ? ex.title : getStudentExerciseTitle(ex, i)}
//                   </h3>

//                   {hasValidHtml(ex.details) && (
//                     <div
//                       className="prose max-w-none bg-blue-50 p-6 rounded-xl border-l-4 border-blue-500 mb-10"
//                       dangerouslySetInnerHTML={{
//                         __html: DOMPurify.sanitize(ex.details),
//                       }}
//                     />
//                   )}

//                   {!isSection && (
//                     <div className="bg-white rounded-xl p-6 border shadow-sm">
//                       <Comp
//                         exercise={ex}
//                         isPreview={true}
//                         showResult={isSubmitted}
//                         onComplete={(correct) =>
//                           handleExerciseComplete(ex._id, correct)
//                         }
//                       />
//                     </div>
//                   )}
//                 </section>
//               );
//             })}
//           </CardContent>

//           <CardFooter className="flex justify-between p-6 bg-blue-50 border-t">
//             <Button
//               variant="outline"
//               disabled={!isSubmitted && !allExercisesDone}
//               onClick={() => navigate(-1)}
//             >
//               ← Previous
//             </Button>
//             <Button
//               onClick={() => navigate(`/courses/${slug}/result`)}
//               className="gap-2"
//             >
//               Continue <ArrowRight className="w-4 h-4" />
//             </Button>
//           </CardFooter>
//         </Card>
//       </main>
//     </div>
//   );
// }

// import React, { useEffect, useRef, useState, useMemo } from "react";
// import { useSelector } from "react-redux";
// import { useParams, useNavigate } from "react-router-dom";
// import DOMPurify from "dompurify";

// import {
//   useGetCourseBySlugQuery,
//   useGetCourseProgressQuery,
// } from "@/features/api/courseApi";
// import { useCheckEnrollmentQuery } from "@/features/api/orderApi";

// import { Button } from "@/components/ui/button";
// import { Card, CardContent, CardFooter } from "@/components/ui/card";
// import { Progress } from "@/components/ui/progress";
// import { Skeleton } from "@/components/ui/skeleton";

// import {
//   CheckCircle2,
//   PlayCircle,
//   ArrowRight,
//   BookOpen,
//   ChevronRight,
// } from "lucide-react";

// /* ================= EXERCISES ================= */
// import MultipleChoiceExercise from "@/assets/AllCourses/Exercises/MultipleChoice";
// import FillInTheBlanksExercise from "@/assets/AllCourses/Exercises/FillInTheBlanks";
// import PictureFillInTheBlanksExercise from "@/assets/AllCourses/Exercises/PictureFillInTheBlanks";
// import MatchingExercise from "@/assets/AllCourses/Exercises/Matching";
// import PronunciationExercise from "@/assets/AllCourses/Exercises/Pronunciation";
// import ListeningExercise from "@/assets/AllCourses/Exercises/Listening";
// import DragAndDropExercise from "@/assets/AllCourses/Exercises/DragAndDrop";
// import CategorizingWordsExercise from "@/assets/AllCourses/Exercises/CategorizingWords";
// import CircleTheCorrectWordExercise from "@/assets/AllCourses/Exercises/CircleTheCorrectWord";
// import CompleteTheConversationExercise from "@/assets/AllCourses/Exercises/CompleteTheConversation";
// import CompleteTheSentencesExercise from "@/assets/AllCourses/Exercises/CompleteTheSentences";
// import CrosswordExercise from "@/assets/AllCourses/Exercises/Crossword";
// import MissingAlphabetsExercise from "@/assets/AllCourses/Exercises/MissingAlphabets";
// import SentenceJumblesExercise from "@/assets/AllCourses/Exercises/SentenceJumbles";
// import StressingSyllableWordsExercise from "@/assets/AllCourses/Exercises/StressingSyllableWords";
// import VocabularyBuildingExercise from "@/assets/AllCourses/Exercises/VocabularyBuilding";
// import WordFormationExercise from "@/assets/AllCourses/Exercises/WordFormation";
// import WordJumblesExercise from "@/assets/AllCourses/Exercises/WordJumbles";

// /* ================= CONSTANT ================= */
// const SCROLL_OFFSET = 140;

// /* ================= EXERCISE MAP ================= */
// const exerciseComponents = {
//   "multiple-choice": MultipleChoiceExercise,
//   "fill-in-the-blanks": FillInTheBlanksExercise,
//   "picture-fill-in-the-blanks": PictureFillInTheBlanksExercise,
//   matching: MatchingExercise,
//   pronunciation: PronunciationExercise,
//   listening: ListeningExercise,
//   "drag-and-drop": DragAndDropExercise,
//   "categorizing-words": CategorizingWordsExercise,
//   "circle-the-correct-word": CircleTheCorrectWordExercise,
//   "complete-the-conversation": CompleteTheConversationExercise,
//   "complete-the-sentences": CompleteTheSentencesExercise,
//   crossword: CrosswordExercise,
//   "missing-alphabets": MissingAlphabetsExercise,
//   "sentence-jumbles": SentenceJumblesExercise,
//   "stressing-syllable-words": StressingSyllableWordsExercise,
//   "vocabulary-building": VocabularyBuildingExercise,
//   "word-formation": WordFormationExercise,
//   "word-jumbles": WordJumblesExercise,
//   "exercise-section": () => null,
// };

// /* ================= HELPERS ================= */
// const getStudentExerciseTitle = (ex, index) =>
//   ex?.title?.trim() || `Exercise ${index + 1}`;

// const hasValidHtml = (html) =>
//   typeof html === "string" &&
//   html.replace(/<[^>]*>/g, "").trim().length > 0;

// /* ================= COMPONENT ================= */
// export default function CourseLearningPage() {
//   const { slug } = useParams();
//   const navigate = useNavigate();
//   const user = useSelector((s) => s.auth?.user);

//   const exerciseRefs = useRef([]);
//   const redirectOnce = useRef(false);

//   const [currentLessonId, setCurrentLessonId] = useState(null);
//   const [expandedLessonId, setExpandedLessonId] = useState(null);
//   const [currentExerciseIndex, setCurrentExerciseIndex] = useState(null);
//   const [completedLessons, setCompletedLessons] = useState([]);
//   const [exerciseAttempts, setExerciseAttempts] = useState({});

//   /* ================= DATA ================= */
//   const { data, isLoading, error } = useGetCourseBySlugQuery(slug, {
//     skip: !slug,
//   });

//   const course = data?.course;

//   const { data: enrollmentData, isLoading: enrollmentLoading } =
//     useCheckEnrollmentQuery(course?._id, {
//       skip: !course?._id || !user,
//     });

//   const { data: progressData, isLoading: progressLoading } =
//     useGetCourseProgressQuery(course?._id, {
//       skip: !course?._id || !user,
//     });

//   const lessons = useMemo(() => course?.lessons || [], [course]);

//   const currentLesson = useMemo(() => {
//     if (!lessons.length) return null;
//     return lessons.find((l) => l._id === currentLessonId) || lessons[0];
//   }, [currentLessonId, lessons]);

//   const exercises = currentLesson?.exercises || [];

//   /* ================= ACCESS CONTROL (SAFE) ================= */
//   useEffect(() => {
//     if (redirectOnce.current) return;

//     if (!user) {
//       redirectOnce.current = true;
//       navigate("/login", { replace: true });
//       return;
//     }

//     if (!course || enrollmentLoading) return;

//     if (course.price > 0 && enrollmentData && !enrollmentData.enrolled) {
//       redirectOnce.current = true;
//       navigate(`/courses/${slug}`, { replace: true });
//     }
//   }, [user, course, enrollmentData, enrollmentLoading, slug, navigate]);

//   /* ================= GROUP EXERCISES ================= */
//   const groupedExercisesForTOC = useMemo(() => {
//     const groups = [];
//     let currentGroup = { title: "Exercises", exercises: [] };

//     exercises.forEach((ex, index) => {
//       if (ex.type === "exercise-section") {
//         if (currentGroup.exercises.length) groups.push(currentGroup);
//         currentGroup = {
//           title: ex.title?.trim() || "Section",
//           exercises: [],
//         };
//       } else {
//         currentGroup.exercises.push({
//           ...ex,
//           originalIndex: index,
//         });
//       }
//     });

//     if (currentGroup.exercises.length) groups.push(currentGroup);
//     return groups;
//   }, [exercises]);

//   /* ================= SCROLL SPY ================= */
//   useEffect(() => {
//     if (!exercises.length) return;

//     const onScroll = () => {
//       let active = null;
//       exerciseRefs.current.forEach((el, i) => {
//         if (el && el.getBoundingClientRect().top - SCROLL_OFFSET <= 0) {
//           active = i;
//         }
//       });
//       if (active !== null) setCurrentExerciseIndex(active);
//     };

//     window.addEventListener("scroll", onScroll, { passive: true });
//     onScroll();
//     return () => window.removeEventListener("scroll", onScroll);
//   }, [exercises]);

//   /* ================= LOAD PROGRESS ================= */
//   useEffect(() => {
//     if (!progressData || !lessons.length) return;

//     setCompletedLessons(progressData.completedLessons || []);
//     const lessonId = progressData.currentLessonId || lessons[0]._id;
//     setCurrentLessonId(lessonId);
//     setExpandedLessonId(lessonId);
//   }, [progressData, lessons]);

//   /* ================= COMPLETE ================= */
//   const handleExerciseComplete = (id, correct) => {
//     if (!id) return;
//     setExerciseAttempts((p) => ({ ...p, [id]: correct }));
//   };

//   const realExercisesCount = exercises.filter(
//     (e) => e.type !== "exercise-section"
//   ).length;

//   const allExercisesDone =
//     realExercisesCount > 0 &&
//     Object.keys(exerciseAttempts).length === realExercisesCount;

//   /* ================= LOADING ================= */
//   if (isLoading || enrollmentLoading || progressLoading) {
//     return (
//       <div className="p-8 space-y-4">
//         <Skeleton className="h-10 w-96" />
//         <Skeleton className="h-64 w-full" />
//       </div>
//     );
//   }

//   if (error || !course) {
//     return <div className="p-8 text-red-600">Failed to load course</div>;
//   }

//   /* ================= RENDER ================= */
//   return (
//     <div className="flex flex-col lg:flex-row gap-8 p-6 bg-gray-50 min-h-screen">
//       {/* TOC */}
//       <aside className="lg:w-80 bg-white p-6 rounded-xl shadow-lg lg:sticky top-6 max-h-[calc(100vh-3rem)] overflow-y-auto">
//         <div className="flex items-center gap-3 mb-6">
//           <BookOpen className="w-7 h-7 text-blue-600" />
//           <h2 className="font-bold text-xl">{course.title}</h2>
//         </div>

//         <Progress value={progressData?.percentage || 0} className="h-3 mb-2" />
//         <p className="text-sm text-gray-500 mb-6">
//           {Math.round(progressData?.percentage || 0)}% Completed
//         </p>

//         <nav className="space-y-2">
//           {lessons.map((lesson) => {
//             const isActive = lesson._id === currentLessonId;
//             const isExpanded = expandedLessonId === lesson._id;

//             return (
//               <div key={lesson._id}>
//                 <button
//                   onClick={() => {
//                     setCurrentLessonId(lesson._id);
//                     setExpandedLessonId(isExpanded ? null : lesson._id);
//                   }}
//                   className={`w-full p-3 text-left rounded-lg flex items-center gap-3
//                   ${
//                     isActive
//                       ? "bg-blue-100 border-l-4 border-blue-600 font-semibold"
//                       : "hover:bg-gray-100"
//                   }`}
//                 >
//                   {completedLessons.includes(lesson._id) ? (
//                     <CheckCircle2 className="w-5 h-5 text-green-600" />
//                   ) : (
//                     <PlayCircle className="w-5 h-5 text-gray-400" />
//                   )}
//                   <span className="flex-1 truncate">{lesson.title}</span>
//                   <ChevronRight
//                     className={`w-4 h-4 transition ${
//                       isExpanded ? "rotate-90" : ""
//                     }`}
//                   />
//                 </button>

//                 {isExpanded && isActive && (
//                   <div className="ml-8 mt-3 border-l pl-4 space-y-3">
//                     {groupedExercisesForTOC.map((group, gi) => (
//                       <div key={gi}>
//                         <h4 className="text-sm font-bold text-gray-700">
//                           {group.title}
//                         </h4>

//                         {group.exercises.map((ex) => {
//                           const idx = ex.originalIndex;
//                           const active = idx === currentExerciseIndex;

//                           return (
//                             <button
//                               key={idx}
//                               onClick={() => {
//                                 const el = document.getElementById(
//                                   `exercise-${idx}`
//                                 );
//                                 if (!el) return;
//                                 const y =
//                                   el.getBoundingClientRect().top +
//                                   window.pageYOffset -
//                                   SCROLL_OFFSET;
//                                 window.scrollTo({
//                                   top: y,
//                                   behavior: "smooth",
//                                 });
//                               }}
//                               className={`block w-full text-left px-4 py-2 rounded-md text-sm
//                               ${
//                                 active
//                                   ? "bg-blue-100 text-blue-800 font-semibold border-l-4 border-blue-600"
//                                   : "text-gray-600 hover:bg-gray-100"
//                               }`}
//                             >
//                               {getStudentExerciseTitle(ex, idx)}
//                             </button>
//                           );
//                         })}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </nav>
//       </aside>

//       {/* MAIN */}
//       <main className="flex-1">
//         <Card className="shadow-xl">
//           <CardContent className="space-y-16 py-10">
//             <h1 className="text-4xl font-bold text-blue-900">
//               {currentLesson?.title}
//             </h1>

//             {exercises.map((ex, i) => {
//               const Comp = exerciseComponents[ex.type];
//               if (!Comp) return null;

//               return (
//                 <section
//                   key={i}
//                   id={`exercise-${i}`}
//                   ref={(el) => (exerciseRefs.current[i] = el)}
//                   className="scroll-mt-32"
//                 >
//                   <h3 className="text-2xl font-semibold mb-4">
//                     {ex.type === "exercise-section"
//                       ? ex.title
//                       : getStudentExerciseTitle(ex, i)}
//                   </h3>

//                   {hasValidHtml(ex.details) && (
//                     <div
//                       className="prose max-w-none bg-blue-50 p-6 rounded-xl border-l-4 border-blue-500 mb-8"
//                       dangerouslySetInnerHTML={{
//                         __html: DOMPurify.sanitize(ex.details),
//                       }}
//                     />
//                   )}

//                   {ex.type !== "exercise-section" && (
//                     <div className="bg-white p-6 rounded-xl border shadow-sm">
//                       <Comp
//                         exercise={ex}
//                         isPreview
//                         onComplete={handleExerciseComplete}
//                       />
//                     </div>
//                   )}
//                 </section>
//               );
//             })}
//           </CardContent>

//           <CardFooter className="flex justify-between p-6 bg-blue-50 border-t">
//             <Button variant="outline" onClick={() => navigate(-1)}>
//               ← Previous
//             </Button>
//             <Button
//               disabled={!allExercisesDone}
//               onClick={() => navigate(`/courses/${slug}/result`)}
//             >
//               Continue <ArrowRight className="w-4 h-4 ml-2" />
//             </Button>
//           </CardFooter>
//         </Card>
//       </main>
//     </div>
//   );
// }




"use client";

import React, { useEffect, useRef, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";

import {
  useGetCourseBySlugQuery,
  useStartLessonExerciseMutation,
  useSaveExerciseAnswerMutation,
  useSubmitLessonExerciseMutation,
  useLazyGetLessonResultQuery,
  useUpdateLessonCompletionMutation
} from "@/features/api/courseApi";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Skeleton } from "@/components/ui/skeleton";

import {
  CheckCircle2,
  PlayCircle,
  ArrowRight,
  BookOpen,
  ChevronRight
} from "lucide-react";

/* ================= EXERCISES ================= */

import MultipleChoiceExercise from "@/assets/AllCourses/Exercises/MultipleChoice";
import FillInTheBlanksExercise from "@/assets/AllCourses/Exercises/FillInTheBlanks";
import PictureFillInTheBlanksExercise from "@/assets/AllCourses/Exercises/PictureFillInTheBlanks";
import MatchingExercise from "@/assets/AllCourses/Exercises/Matching";
import PronunciationExercise from "@/assets/AllCourses/Exercises/Pronunciation";
import ListeningExercise from "@/assets/AllCourses/Exercises/Listening";
import DragAndDropExercise from "@/assets/AllCourses/Exercises/DragAndDrop";
import CategorizingWordsExercise from "@/assets/AllCourses/Exercises/CategorizingWords";
import CircleTheCorrectWordExercise from "@/assets/AllCourses/Exercises/CircleTheCorrectWord";
import CompleteTheConversationExercise from "@/assets/AllCourses/Exercises/CompleteTheConversation";
import CompleteTheSentencesExercise from "@/assets/AllCourses/Exercises/CompleteTheSentences";
import CrosswordExercise from "@/assets/AllCourses/Exercises/Crossword";
import MissingAlphabetsExercise from "@/assets/AllCourses/Exercises/MissingAlphabets";
import SentenceJumblesExercise from "@/assets/AllCourses/Exercises/SentenceJumbles";
import StressingSyllableWordsExercise from "@/assets/AllCourses/Exercises/StressingSyllableWords";
import VocabularyBuildingExercise from "@/assets/AllCourses/Exercises/VocabularyBuilding";
import WordFormationExercise from "@/assets/AllCourses/Exercises/WordFormation";
import WordJumblesExercise from "@/assets/AllCourses/Exercises/WordJumbles";

/* ================= CONSTANTS ================= */

const PASS_PERCENT = 30;
const SCROLL_OFFSET = 140;

/* ================= EXERCISE MAP ================= */

const exerciseComponents = {
  "multiple-choice": MultipleChoiceExercise,
  "fill-in-the-blanks": FillInTheBlanksExercise,
  "picture-fill-in-the-blanks": PictureFillInTheBlanksExercise,
  matching: MatchingExercise,
  pronunciation: PronunciationExercise,
  listening: ListeningExercise,
  "drag-and-drop": DragAndDropExercise,
  "categorizing-words": CategorizingWordsExercise,
  "circle-the-correct-word": CircleTheCorrectWordExercise,
  "complete-the-conversation": CompleteTheConversationExercise,
  "complete-the-sentences": CompleteTheSentencesExercise,
  crossword: CrosswordExercise,
  "missing-alphabets": MissingAlphabetsExercise,
  "sentence-jumbles": SentenceJumblesExercise,
  "stressing-syllable-words": StressingSyllableWordsExercise,
  "vocabulary-building": VocabularyBuildingExercise,
  "word-formation": WordFormationExercise,
  "word-jumbles": WordJumblesExercise,
  "exercise-section": () => null
};

const getStudentExerciseTitle = (ex, index) =>
  ex?.title?.trim() || `Exercise ${index + 1}`;

const hasValidHtml = (html) =>
  typeof html === "string" &&
  html.replace(/<[^>]*>/g, "").trim().length > 0;

/* ================= COMPONENT ================= */

export default function CourseLearningPage() {

const { slug } = useParams();
const navigate = useNavigate();
const user = useSelector((s) => s.auth?.user);

const exerciseRefs = useRef([]);

const [currentLessonId, setCurrentLessonId] = useState(null);
const [expandedLessonId, setExpandedLessonId] = useState(null);
const [currentExerciseIndex, setCurrentExerciseIndex] = useState(null);

const [answers, setAnswers] = useState({});
const [attemptId, setAttemptId] = useState(null);

const [showResult,setShowResult]=useState(false)
const [retryMode,setRetryMode]=useState(false)
const [scorePercent,setScorePercent]=useState(0)

/* ================= API ================= */

const { data, isLoading } = useGetCourseBySlugQuery(slug);

const course = data?.course;

const lessons = course?.lessons || [];

const currentLesson = useMemo(() => {
if (!currentLessonId && lessons.length > 0) return lessons[0]
return lessons.find(l=>l._id===currentLessonId) || lessons[0]
},[currentLessonId,lessons])

const exercises = currentLesson?.exercises || []

const [startAttempt]=useStartLessonExerciseMutation()
const [saveAnswer]=useSaveExerciseAnswerMutation()
const [submitAttempt]=useSubmitLessonExerciseMutation()
const [getResult]=useLazyGetLessonResultQuery()
const [updateLessonCompletion]=useUpdateLessonCompletionMutation()

/* ================= START ATTEMPT ================= */

useEffect(()=>{

if(!currentLesson?._id) return;

async function start(){

try{

const res = await startAttempt({
lessonId: currentLesson._id
}).unwrap();

setAttemptId(res?.attemptId);

}catch(err){
console.error("Start attempt failed", err);
}

}

start();

},[currentLesson?._id]);

/* ================= HANDLE ANSWER ================= */

const handleExerciseComplete = async(id,answer,correct)=>{

setAnswers(prev=>({
...prev,
[id]:{answer,correct}
}))

try{
if (!attemptId) return;

await saveAnswer({
  attemptId,
  exerciseId: id,
  answer,
  correct
});

}catch{}
}

/* ================= SCROLL SPY ================= */

useEffect(()=>{
const onScroll=()=>{
let active=null
exerciseRefs.current.forEach((el,i)=>{
if(el && el.getBoundingClientRect().top-SCROLL_OFFSET<=0){
active=i
}
})
if(active!==null) setCurrentExerciseIndex(active)
}

window.addEventListener("scroll",onScroll)
return()=>window.removeEventListener("scroll",onScroll)

},[exercises])

/* ================= EXERCISE COUNT ================= */

const realExercises = useMemo(() => 
  exercises.filter(e => e.type !== "exercise-section"),
  [exercises]
);

const answeredExercises = Object.keys(answers).filter(
(id) => realExercises.some((ex) => ex._id === id)
).length;

const allAnswered =
  realExercises.length > 0 &&
  answeredExercises === realExercises.length;



/* ================= SUBMIT ================= */

const submitLesson=async()=>{

await submitAttempt({
  attemptId,
  answers: Object.entries(answers).map(([exerciseId, data]) => ({
    exerciseId,
    answer: data.answer,
    correct: data.correct
  }))
}).unwrap();


const result=await getResult(attemptId).unwrap()

const percent=result.scorePercent || 0

setScorePercent(percent)
setShowResult(true)

if(percent < PASS_PERCENT){
setRetryMode(true)
return
}

await updateLessonCompletion({
courseId:course._id,
lessonId:currentLesson._id,
completed:true,
score:percent
})

const currentIndex = lessons.findIndex(
l=>l._id===currentLesson._id
)

const nextLesson = lessons[currentIndex+1]

if(nextLesson){

setCurrentLessonId(nextLesson._id)

}else{

navigate(`/courses/${slug}/result`)

}

}

/* ================= RETRY ================= */

const retryLesson=()=>{
setAnswers({})
setShowResult(false)
setRetryMode(false)
}

/* ================= LOADING ================= */

if(isLoading){
return(
<div className="p-8 space-y-4">
<Skeleton className="h-10 w-96"/>
<Skeleton className="h-64 w-full"/>
</div>
)
}

/* ================= UI ================= */

return (

<div className="flex flex-col lg:flex-row gap-8 p-6 bg-gray-50 min-h-screen">

{/* ================= LEFT TOC ================= */}

<aside className="lg:w-80 bg-white p-6 rounded-xl shadow-lg sticky top-6 h-fit">

<div className="flex items-center gap-3 mb-6">
<BookOpen className="w-7 h-7 text-blue-600"/>
<h2 className="font-bold text-xl">{course?.title}</h2>
</div>

<nav className="space-y-2">

{lessons.map((lesson)=>{

const isActive = lesson._id===currentLesson?._id

return(

<button
key={lesson._id}
onClick={()=>setCurrentLessonId(lesson._id)}
className={`w-full text-left p-3 rounded-lg flex gap-3
${isActive?"bg-blue-100 font-semibold":"hover:bg-gray-100"}
`}
>

<PlayCircle className="w-5 h-5"/>

<span>{lesson.title}</span>

</button>

)

})}

</nav>

</aside>


{/* ================= RIGHT CONTENT ================= */}

<main className="flex-1">

<Card className="shadow-xl">

<CardContent className="space-y-16 py-10">

<h1 className="text-4xl font-bold text-blue-900">
{currentLesson?.title}
</h1>

{exercises.map((ex,i)=>{

if (ex.type === "exercise-section") {
  return (
    <div key={i} className="pt-10">
      <h2 className="text-3xl font-bold text-blue-800">
        {ex.title}
      </h2>
    </div>
  );
}


const Comp = exerciseComponents[ex.type];
if (!Comp) return null;


const correct = answers[ex._id]?.correct

return(

<section
key={ex._id}
ref={el=>exerciseRefs.current[i]=el}
>

<h3 className="text-2xl font-semibold mb-6">
{getStudentExerciseTitle(ex,i)}
</h3>

{hasValidHtml(ex.details) && (
<div
className="prose max-w-none bg-blue-50 p-6 rounded-xl border-l-4 border-blue-500 mb-10"
dangerouslySetInnerHTML={{
__html:DOMPurify.sanitize(ex.details)
}}
/>
)}

<div
className={`rounded-xl p-6 border transition
${showResult
? correct
? "bg-green-50 border-green-400"
: "bg-red-50 border-red-400"
: "bg-white border-gray-200"}
`}
>


<Comp
exercise={ex}
showResult={showResult}
onComplete={(answer,correct)=>
handleExerciseComplete(ex._id,answer,correct)
}
/>

</div>

</section>

)

})}

</CardContent>


<CardFooter className="flex justify-between p-6 bg-blue-50 border-t">

<Button variant="outline" onClick={()=>navigate(-1)}>
← Previous
</Button>

{retryMode ? (

<Button
variant="destructive"
onClick={retryLesson}
>
Retry
</Button>

) : (

<Button
 disabled={!allAnswered}
 onClick={submitLesson}
 className="gap-2"
>
 Continue
 <ArrowRight className="w-4 h-4"/>
</Button>


)}

</CardFooter>

</Card>

</main>

</div>

)

}
